module.exports = " <div class=breadcrumbs> <a href=\"\" v-for=\"(i, part) in pathParts\" @click.prevent=selectFolder(i)> <span class=\"icon icon-folder\"></span> {{ part }} </a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/assets/Browser/Breadcrumbs.vue
// module id = 324
// module chunks = 0